const apiUrl = process.env.REACT_APP_API_BASE_URL;

module.exports = {
    //Login
    AUTHENTICATE_USER: `${apiUrl}/api/User/email`,
    USER_ROLE: `${apiUrl}/api/User/id`,

    //Change Password
    CHANGE_PASSWORD: `${apiUrl}/api/User/password`,

   //User Management 
   /* USER_DATA: `${apiUrl}/api/User/User`, */
   USER_MANAGEMENT: `${apiUrl}/api/User/Users`,
   GET_USER: `${apiUrl}/api/User/GetUser/`,
   ADDUSER_MANAGEMENT: `${apiUrl}/api/User/AddUser`,
   CHANGE_USERSTATUS: `${apiUrl}/api/User/ChangesUserStaus`,
   DELETE_USERID: `${apiUrl}/api/User/Delete`,

   //HistoryLog
    HISTORY_LOG: `${apiUrl}/api/ShipHistory/`,

    //ExternalClient
    GET_EXTERNAL_CLIENT_SHIPS:`${apiUrl}/api/ships/externalClient`,
    POST_EXTERNAL_CLIENT:`${apiUrl}/api/User/ship/ExternalClient`,
    GET_EXTERNAL_CLIENT:`${apiUrl}/api/User/ship/ExternalClient`,

    //Ship Management
    GET_SHIP: `${apiUrl}/api`,
    GET_SHIPNAMES : `${apiUrl}/api/shipList`,
    ADDEDIT_PROJECT: `${apiUrl}/api/ship`,
    ADDEDIT_LOGO: `${apiUrl}/api/ShipPhoto`,
    DELETE_SHIP: `${apiUrl}/api/Ship/`,
    ASSIGN_USER: `${apiUrl}/api/AssginUsers`,
    SHIP_LOGO: `${apiUrl}/api/ShipPhoto/`,
    UPDATE_STATUS: `${apiUrl}/api/Ship/updateStatus`,

    // Ship Settings
    GET_TIMEZONE: `${apiUrl}/api/TimeZone`,
    GET_DATEFORMAT: `${apiUrl}/api/TimeFormat`,
    SETTINGS_SHIP: `${apiUrl}/api/Ship/Setting`,
    SETTINGS_SHIP_POST: `${apiUrl}/api/Ship/Setting`,
    
    //Add Vessel Particular
    AddEdit_Vessel: `${apiUrl}/api/inspectionTask/addOrUpdateVessel`,
    Get_Vessel:`${apiUrl}/api/inspectionTask/getVessel`,
   
    //Lookup
    Get_ShipStatusList:`${apiUrl}/api/lookup/getLookup`,
    Get_Countries: `${apiUrl}/api/lookup/getShips`,
    
    //Inspection Summary
    AddEdit_Inspection:`${apiUrl}/api/inspectionTask/addSummary`,
    Get_Inspection:`${apiUrl}/api/inspectionTask/getSummary`,

    //Ahead Grade
    Get_AheadGrade:`${apiUrl}/api/inspectionTask/getAheadGrade`,
   
     //KeyNotableItems
     AddEdit_Notable:`${apiUrl}/api/inspectionTask/addOrUpdateNotableItems`,
     Get_Notable:`${apiUrl}/api/inspectionTask/getNotableItems`,
     Delete_Inspection: `${apiUrl}/api/inspectionTask/deleteItem`,

     //GradingData
     AddEdit_Grading:`${apiUrl}/api/inspectionTask/addGradingdata`,
     Get_Grading:`${apiUrl}/api/inspectionTask/getGradingdata`,

     //Richtext
     AddEdit_Richtext:`${apiUrl}/api/inspectionTask/addRichText`,
     Get_Richtext:`${apiUrl}/api/inspectionTask/getRichText`,

     //Images
     Delete_images:`${apiUrl}/api/inspectionTask/deleteImage`,
     AddEdit_Images:`${apiUrl}/api/inspectionTask/addImages`,
     Get_Images:`${apiUrl}/api/inspectionTask/getImages`,

    //CheckList
    AddEdit_checklist:`${apiUrl}/api/inspectionTask/updateAnswers`,
    Get_Checklist:`${apiUrl}/api/inspectionTask/getQuestions`,
    Get_ChecklistByInspection:`${apiUrl}/api/inspectionTask/getQuestionsByInspection`,
    Get_CIICOMPLIANCE:`${apiUrl}/api/inspectionTask/GetDecarbanizationData`,
    UpdateQuestions:`${apiUrl}/api/inspectionTask/updateQuestions`,

    //Checklist Comments
    Get_Checklist_comments:`${apiUrl}/api/inspectionTask/getSectionComments`,
    AddEdit_checklist_comments:`${apiUrl}/api/inspectionTask/updateSectionComments`,

    //Final Report
    FINAL_REPORTSHOW: `${apiUrl}/Report`,
    FINAL_REPORT_DOWN: `${apiUrl}/api/pdf/Download`,

    //Documents
    GET_Document: `${apiUrl}/api/Documents/List`,
    DELETE_Document: `${apiUrl}/api/Documents`,
    POST_Document: `${apiUrl}/api/Documents/ProcessDocument`,
    Update_Document: `${apiUrl}/api/Documents/UpdateDocumentField`,
    Download_Document:`${apiUrl}/api/Documents/download/documents`,

    //Download All Documents/Photographs
    Download_Zip_Files:`${apiUrl}/api/Documents/files/ZipDownload`,

    //shipImages
    GET_ShipImages: `${apiUrl}/api/Documents/ImagesList`,
    DELETE_ShipImages: `${apiUrl}/api/Documents/projectImageIds`,
    POST_ShipImages: `${apiUrl}/api/Documents/ProcessImage`,
    Update_ShipImages: `${apiUrl}/api/Documents/UpdateImageField`,

    //New Enquiry
    POST_Enquiry: `${apiUrl}/api/enquiry`,
  
};
